import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumbItem = _resolveComponent("FKBreadCrumbItem")!
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_PatientAnagraph = _resolveComponent("PatientAnagraph")!
  const _component_CaregiversList = _resolveComponent("CaregiversList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.$t('page.caregivers')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.patients'),
          to: "/patients"
        }, null, 8 /* PROPS */, ["page"]),
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.patient_fullname,
          to: `/patient/${_ctx.patient.id}`
        }, null, 8 /* PROPS */, ["page", "to"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page"]),
    _createVNode(_component_PatientAnagraph, {
      minimal: true,
      class: "patient-info-header border-bottom cursor-pointer",
      onClick: _ctx.back
    }, null, 8 /* PROPS */, ["onClick"]),
    _createVNode(_component_CaregiversList)
  ], 64 /* STABLE_FRAGMENT */))
}